import { createSmartTaxUploadCard } from './createSmartTaxUploadCard';
import {
  SMART_TAX_DELIVERY_CARD_CONFIG,
  SmartTaxDeliveryTechnicalSpecs,
} from './smartTaxImportCards';

export const SmartTaxDeliveryUploadCard = createSmartTaxUploadCard(
  SMART_TAX_DELIVERY_CARD_CONFIG,
  SmartTaxDeliveryTechnicalSpecs
);
